/**
 * Reads the schema skew store (`schemaSkew.ts`) in a component, re-rendering
 * whenever it changes.
 */

import { useEffect, useState } from "react";
import { subscribeSchemaSkew } from "./schemaSkew";

/** `snapshot` of the schema skew store, as of the last change. */
export default function useSchemaSkew<T>(snapshot: () => T): T {
  const [value, setValue] = useState(snapshot);
  useEffect(() => {
    // A change between the first render and subscribing is not missed.
    setValue(() => snapshot());
    return subscribeSchemaSkew(() => setValue(() => snapshot()));
  }, [snapshot]);
  return value;
}
